import React, { useEffect } from 'react';

const RecordOptionsModal = ({ show, onClose, onOngoing, onNew, ongoingSessionExists }) => {
  useEffect(() => {
    if (show && !ongoingSessionExists) {
      onNew();
      onClose();
    } 
  }, [show, ongoingSessionExists, onNew, onClose]);

  if (!show || !ongoingSessionExists) {
    return null;
  }

  return (
    <>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes scaleIn {
          from { 
            opacity: 0;
            transform: scale(0.95) translateY(-10px);
          }
          to { 
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }
        .modal-button {
          transition: all 0.2s ease;
        }
        .modal-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(37,99,235,0.25);
          background: #1d4ed8;
        }
        .modal-button:active {
          transform: translateY(0);
        }
        .close-button {
          transition: all 0.15s ease;
        }
        .close-button:hover {
          color: #333;
          transform: scale(1.1);
        }
      `}</style>
      
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.45)',
        backdropFilter: 'blur(4px)',
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        animation: 'fadeIn 0.2s ease-out'
      }}>
        <div style={{
          background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
          borderRadius: 20,
          padding: '40px 36px',
          minWidth: 360,
          maxWidth: 420,
          boxShadow: '0 20px 60px rgba(0,0,0,0.15), 0 0 1px rgba(0,0,0,0.1)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          animation: 'scaleIn 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)',
          position: 'relative',
          border: '1px solid rgba(255,255,255,0.8)'
        }}>
          <button
            onClick={onClose}
            className="close-button"
            style={{
              position: 'absolute',
              top: 16,
              right: 20,
              background: 'transparent',
              border: 'none',
              fontSize: 28,
              color: '#94a3b8',
              cursor: 'pointer',
              fontWeight: 300,
              lineHeight: 1,
              padding: 0,
              width: 28,
              height: 28,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            aria-label="Close"
          >
            ×
          </button>

          <div style={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 20,
            boxShadow: '0 8px 20px rgba(37,99,235,0.25)'
          }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <circle cx="12" cy="12" r="3"/>
            </svg>
          </div>

          <h4 style={{ 
            marginBottom: 10, 
            color: '#1e293b', 
            fontWeight: 700,
            fontSize: 22,
            letterSpacing: '-0.02em'
          }}>
            Choose Recording Option
          </h4>

          <p style={{
            color: '#64748b',
            fontSize: 14,
            marginBottom: 32,
            textAlign: 'center',
            lineHeight: 1.5
          }}>
            Continue with your ongoing session or start fresh
          </p>

          <button
            className="modal-button"
            style={{
              background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
              color: 'white',
              border: 'none',
              borderRadius: 12,
              padding: '14px 32px',
              fontSize: 15,
              fontWeight: 600,
              marginBottom: 14,
              width: '100%',
              maxWidth: 280,
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(37,99,235,0.2)',
              letterSpacing: '0.01em'
            }}
            onClick={() => {
              onOngoing();
              onClose();
            }}
          >
            📊 Ongoing Recording
          </button>

          <button
            className="modal-button"
            style={{
              background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
              color: 'white',
              border: 'none',
              borderRadius: 12,
              padding: '14px 32px',
              fontSize: 15,
              fontWeight: 600,
              width: '100%',
              maxWidth: 280,
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(14,165,233,0.2)',
              letterSpacing: '0.01em'
            }}
            onClick={() => {
              onNew();
              onClose();
            }}
          >
            ✨ New Recording
          </button>
        </div>
      </div>
    </>
  );
};

export default RecordOptionsModal;